module.exports = __webpack_public_path__ + "img/HotspotInfo.4c8b1141.png";